import React from 'react'
import TableLayout from './TableLayout'
import { Button, Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'

const ErrorCatchLayout = ({ error, refetch }: { error: any, refetch: (_: any) => void }) => {

    const { t } = useTranslation()
    
    return (
        <TableLayout>
            {
                error?.forbidden ?
                    <Typography variant='lead' className='text-[20px] font-medium text-center my-[40px]'>
                        {t('tables.error_on_roles_view')}
                    </Typography>
                    :
                    <div className="flex flex-col items-center gap-[40px] my-[40px]">
                        <Typography variant='lead' className='des:text-[20px] font-medium text-center '>
                            {t('tables.error_on_loading')}
                        </Typography>
                        <Button onClick={refetch} color='black'>
                            {t('reload')}
                        </Button>
                    </div>
            }
        </TableLayout>
    )
}

export default ErrorCatchLayout